/* eslint-disable camelcase */
import axios from 'axios';
import type { CamelCasedProperties } from 'type-fest';

export type EmailRecipients = string[];
type GetEmailsResponseDTO = {
  success: boolean;
  email_recipients: EmailRecipients;
};

type EmailsResponse = CamelCasedProperties<GetEmailsResponseDTO>;

function mapGetEmailsResponseDTOtoModel(response: GetEmailsResponseDTO): EmailsResponse {
  const { success, email_recipients } = response;
  return {
    success,
    emailRecipients: email_recipients,
  };
}

const API_ROOT = '/api/v1/accounts/';

export async function getEmailRecipients(accountId: number): Promise<EmailsResponse> {
  try {
    const { data } = await axios.get<GetEmailsResponseDTO>(
      `${API_ROOT}${accountId}/email-recipients`,
    );
    return mapGetEmailsResponseDTOtoModel(data);
  } catch {
    return {
      success: false,
      emailRecipients: [],
    };
  }
}

type PersistEmailsResponse = {
  success: boolean;
};

export async function persistEmailRecipients(
  accountId: number,
  emailRecipients: EmailRecipients,
): Promise<PersistEmailsResponse> {
  try {
    await axios.put<PersistEmailsResponse>(`${API_ROOT}${accountId}/email-recipients`, {
      email_recipients: emailRecipients,
    });

    return {
      success: true,
    };
  } catch {
    return {
      success: false,
    };
  }
}

export const api = {
  persistEmailRecipients,
};
